/**
 * Guide · Admin — documents the admin-only surfaces. The topic is gated twice:
 * its nav entry is hidden for non-admins (GuideShell), and this page itself
 * route-guards with a redirect to /guide, mirroring AdminRoute so a non-admin
 * who deep-links the URL never sees admin copy.
 */

import { Navigate } from "react-router";

import { GuidePage } from "@/features/guide/guide-page";
import { useMe } from "@/lib/api";

export function GuideAdminPage() {
  const { data: me, isLoading } = useMe();
  // Fail closed: render nothing while the role is unresolved, and redirect
  // unless the resolved role is explicitly admin — a non-admin deep link must
  // never flash admin copy during the loading window (mirrors AdminRoute).
  if (isLoading) {
    return null;
  }
  if (me?.role !== "admin") {
    return <Navigate to="/guide" replace />;
  }

  return (
    <GuidePage
      eyebrow="Admin"
      title="Admin-only surfaces."
      intro="The Admin section is gated to the admin role. It groups the controls that shape the pilot but should never be exposed to regular users: managing people and watching usage."
      liveBullets={[
        { text: "Users — invite people into the pilot and manage their roles" },
        { text: "Activity — usage analytics across the app" },
      ]}
      cta={{ to: "/admin/users", label: "Open user management" }}
    />
  );
}
